import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgActivityAdded = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 20,
	viewBox: "0 0 19 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4.78125 9.74831L8.05906 12.3745L17.6625 1.48633",
			stroke: "currentColor",
			strokeWidth: 1.3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.3783 17.8453C12.2473 18.3629 10.9822 18.6504 9.65001 18.6504C4.68537 18.6504 0.650391 14.6248 0.650391 9.65039C0.650391 4.67595 4.67578 0.650391 9.65001 0.650391C11.1452 0.650391 12.5636 1.01461 13.8 1.66636",
			stroke: "currentColor",
			strokeWidth: 1.3,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.3545 12.373V18.0855",
			stroke: "currentColor",
			strokeWidth: 1.3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.499 15.2285H18.2208",
			stroke: "currentColor",
			strokeWidth: 1.3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgActivityAdded;
